import { useEffect, useState } from "react";

const Results = ({ results }) => {
  const [renderedShortResults, setRenderedShortResults] = useState([]);
  const [renderedLongResults, setRenderedLongResults] = useState([]);
  const [renderedBibliographyResults, setRenderedBibliographyResults] =
    useState([]);
  const metrics = {
    long_term_no: results?.long_scale_results?.valid_result_count || 0,
    short_term_no: results?.short_scale_results?.valid_result_count || 0,
    bibliography_no: results?.bibliography_results?.valid_result_count || 0,
  };

  useEffect(() => {
    setRenderedBibliographyResults([]);
    setRenderedLongResults([]);
    setRenderedShortResults([]);
    let globalIndex = 0;
    if (results?.short_scale_results?.results) {
      results.short_scale_results.results.forEach((result) => {
        if (result.filtered_passed) {
          setTimeout(() => {
            setRenderedShortResults((prevResults) => [...prevResults, result]);
          }, 150 * (globalIndex + 1));
          globalIndex++;
        }
      });
    }
    if (results?.long_scale_results?.results) {
      results.long_scale_results.results.forEach((result) => {
        if (result.filtered_passed) {
          setTimeout(() => {
            setRenderedLongResults((prevResults) => [...prevResults, result]);
          }, 150 * (globalIndex + 1));
          globalIndex++;
        }
      });
    }
    if (results?.bibliography_results?.results) {
      results.bibliography_results.results.forEach((result) => {
        if (result.filtered_passed) {
          setTimeout(() => {
            setRenderedBibliographyResults((prevResults) => [
              ...prevResults,
              result,
            ]);
          }, 150 * (globalIndex + 1));
          globalIndex++;
        }
      });
    }
  }, [results]);

  return (
    <>
      <ResultsMetrics metrics={metrics} />
      <section className="dss-results">
        <div className="dss-results-container">
          {!!renderedShortResults.length && (
            <>
              <DSSSeparator title="Short Scale Analysis" />
              {renderedShortResults.map((result, index) => (
                <ResultsItem
                  result={result}
                  key={index}
                  source={"Short Scale"}
                />
              ))}
            </>
          )}
          {!!renderedLongResults.length && (
            <>
              <DSSSeparator title="Landscape Analysis" />
              {renderedLongResults.map((result, index) => (
                <ResultsItem result={result} key={index} source={"Landscape"} />
              ))}
            </>
          )}
          {!!renderedBibliographyResults.length && (
            <>
              <DSSSeparator title="Bibliography" />
              {renderedBibliographyResults.map((result, index) => (
                <ResultsItem
                  result={result}
                  key={index}
                  source={"Bibliography"}
                />
              ))}
            </>
          )}
          {!renderedShortResults.length &&
            !renderedLongResults.length &&
            !renderedBibliographyResults.length && (
              <div className="no-results-message">
                No results found. Please try different keywords.
              </div>
            )}
        </div>
      </section>
    </>
  );
};

const ResultsMetrics = ({ metrics }) => {
  return (
    <section className="dss-results-metrics">
      <div className="dss-results-metrics-number" id="short-term">
        Short Scale Analysis: {metrics.short_term_no}
      </div>
      <div className="dss-results-metrics-number" id="long-term">
        Landscape Analysis: {metrics.long_term_no}
      </div>
      <div className="dss-results-metrics-number" id="bibliography">
        Bibliography: {metrics.bibliography_no}
      </div>
    </section>
  );
};
const DSSSeparator = ({ title }) => {
  return (
    <div className="dss-results-separator">
      <span className="dss-separator-title">{title}</span>
      <div className="dss-separator-line" />
    </div>
  );
};

const ResultsItem = ({ result, source }) => {
  const [expanded, setExpanded] = useState(false);
  function openTabs() {
    result.papers.map((paper, index) => {
      window.open(
        paper.paper_url.includes("http")
          ? paper.paper_url
          : `https://doi.org/${paper.paper_url}`,
        "_blank"
      );
    });
  }
  return (
    <>
      {!expanded ? (
        <ResultItemsCard
          result={result}
          source={source}
          expanded={expanded}
          setExpanded={setExpanded}
        />
      ) : (
        <ResultItemsCardExpanded
          result={result}
          source={source}
          expanded={expanded}
          setExpanded={setExpanded}
        />
      )}
    </>
  );
};

const ResultItemsCard = ({ result, source, expanded, setExpanded }) => {
  return (
    <div className="dss-results-item" onClick={() => setExpanded(!expanded)}>
      <header className="dss-results-item-header">
        <div className="dss-results-item-header-source">{source}</div>
        <div
          className={`dss-results-item-header-score ${
            result.best_confidenceScore < 35
              ? "low"
              : result.best_confidenceScore < 75
              ? "medium"
              : "high"
          }`}
        >
          {result.best_confidenceScore < 35
            ? "low"
            : result.best_confidenceScore < 75
            ? "medium"
            : "high"}
        </div>
      </header>

      <div className="dss-results-item-title">{result.mitigationMeasure}</div>
      {result?.monitoringMethod_list ? (
        <>
          {!!result?.monitoringMethod_list.length && (
            <div className="dss-results-item-monitoring-methods">
              <div className="dss-results-item-monitoring-methods-title">
                Monitoring Methods
              </div>
              {result?.monitoringMethod_list.map((method, index) => (
                <ResultsItemsValues title="" value={method} key={index} />
              ))}
            </div>
          )}
          <div className="dss-results-item-subheader-wrapper">
            Measure{" "}
            <div className="dss-results-item-subheader-category">
              {result.filters.category}
            </div>
          </div>
          <div className="dss-results-item-publications">
            <div className="dss-results-item-publications-title">
              Publications
            </div>
            <div className="dss-results-item-publications-list">
              {result.papers.map((paper, index) => (
                <ResultsItemsValues
                  title=""
                  value={paper.paper_id}
                  key={index}
                />
              ))}
            </div>
          </div>
        </>
      ) : (
        result?.filters?.["recommendations and priorities"] && (
          <>
            <div className="dss-results-item-recommendations">
              <div className="dss-results-item-monitoring-methods-title">
                Recom. & Priorities
              </div>
              <ResultsItemsValues
                title=""
                value={result.filters["recommendations and priorities"]}
              />
            </div>
            <div className="dss-results-item-subheader">
              <div className="dss-results-item-subheader-wrapper">
                Measure{" "}
                <div className="dss-results-item-subheader-category">
                  {result.filters.category}
                </div>
              </div>
            </div>
            <div className="dss-results-item-publications-title">
              Source: Triquetra Project
            </div>
          </>
        )
      )}
    </div>
  );
};

const ResultItemsCardExpanded = ({ result, source, expanded, setExpanded }) => {
  console.log(result?.conservation_list);
  return (
    <div
      className="dss-results-item expanded"
      onClick={() => setExpanded(!expanded)}
    >
      <header className="dss-results-item-header">
        <div className="dss-results-item-header-source">{source}</div>
        <div
          className={`dss-results-item-header-score ${
            result.best_confidenceScore < 35
              ? "low"
              : result.best_confidenceScore < 75
              ? "medium"
              : "high"
          }`}
        >
          {result.best_confidenceScore < 35
            ? "low"
            : result.best_confidenceScore < 75
            ? "medium"
            : "high"}{" "}
          - {result.best_confidenceScore}%
        </div>
      </header>

      <div className="dss-results-item-title">{result.mitigationMeasure}</div>
      {!!result?.monitoringMethod_list?.length ? (
        <div className="dss-results-item-monitoring-methods">
          <div className="dss-results-item-monitoring-methods-title">
            Monitoring Methods
          </div>
          {result?.monitoringMethod_list.map((method, index) => (
            <ResultsItemsValues title="" value={method} key={index} />
          ))}
        </div>
      ) : (
        <>
          {result?.filters?.["recommendations and priorities"] && (
            <div className="dss-results-item-recommendations expanded">
              <div className="dss-results-item-monitoring-methods-title">
                Recom. & Priorities
              </div>
              <ResultsItemsValues
                title=""
                value={result.filters["recommendations and priorities"]}
              />
            </div>
          )}
          {!!result?.conservation_list?.length && (
            <div className="dss-results-item-recommendations expanded">
              <div className="dss-results-item-monitoring-methods-title">
                Conservation Methods
              </div>
              <div className="dss-results-item-methods-list">
                {result?.conservation_list.map((method, index) => (
                  <ResultsItemsValues title="" value={method} key={index} />
                ))}
              </div>
            </div>
          )}
          {!!result?.protection_list?.length && (
            <div className="dss-results-item-recommendations expanded">
              <div className="dss-results-item-monitoring-methods-title">
                Protection Methods
              </div>
              <div className="dss-results-item-methods-list">
                {result?.protection_list.map((method, index) => (
                  <ResultsItemsValues title="" value={method} key={index} />
                ))}
              </div>
            </div>
          )}
        </>
      )}
      <div className="dss-results-item-monitoring-filters">
        <ResultsItemsValues
          title="Area of Application"
          value={result.filters?.areaOfApplication || "N/A"}
          reference={result.filters?.references?.areaOfApplication || "#"}
        />
        <ResultsItemsValues
          title="Cost"
          value={result.filters?.cost || "N/A"}
          reference={result.filters?.references?.cost || "#"}
        />
        <ResultsItemsValues
          title="Topological Effect"
          value={result.filters?.topologicalEffect || "N/A"}
          reference={result.filters?.references?.topologicalEffect || "#"}
        />
        <ResultsItemsValues
          title="Implementation Timeframe"
          value={result.filters?.implementationTimeframe || "N/A"}
          reference={result.filters?.references?.implementationTimeframe || "#"}
        />
      </div>
      <div className="dss-results-item-subheader">
        <div className="dss-results-item-subheader-wrapper">
          Measure{" "}
          <div className="dss-results-item-subheader-category">
            {result.filters.category}
          </div>
        </div>
      </div>
      {result?.monitoringMethod_list ? (
        <div className="dss-results-item-publications">
          <div className="dss-results-item-publications-title">
            Publications
          </div>
          <div className="dss-results-item-publications-list">
            {result.papers.map((paper, index) => (
              <a
                className="dss-results-item-publications-list-item"
                key={index}
                href={
                  paper?.paper_url
                    ? paper.paper_url.includes("http")
                      ? paper.paper_url
                      : `https://doi.org/${paper.paper_url}`
                    : null
                }
                target="_blank"
                rel="noopener noreferrer"
              >
                {paper.paper_id}
              </a>
            ))}
          </div>
        </div>
      ) : (
        <div className="dss-results-item-publications-title">
          Source: Triquetra Project
        </div>
      )}
    </div>
  );
};

const ResultsItemsValues = ({ title, value, reference }) => {
  return (
    <div className="dss-results-item-monitoring-methods-list">
      {title}
      <div className="dss-results-item-monitoring-methods-list-item">
        <a href={reference} target="_blank" rel="noopener noreferrer">
          {value !== "N/A" ? value + (!!title ? "/5" : "") : "N/A"}
        </a>
      </div>
    </div>
  );
};

export default Results;
